import React from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import { Mixins } from 'planoplan-ui-kit/core/mixins';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { getImageGroup } from 'planoplan-ui-kit/core/get_image';

export const ListLang = ({ list, onClick }) => {
  return (
    <View>
      <List>
        {list.map((item) => (
          <Item key={item.lang}>
            <Button onClick={() => onClick(item.lang)}>{item.title}</Button>
          </Item>
        ))}
      </List>
    </View>
  );
};

const View = styled.div`
  margin-top: 18px;
  margin-right: 32px;
`;

const List = styled.ul`
  ${Mixins.resetList()};
  position: absolute;
  transform: translateX(-50%);
  border-radius: 4px;
  background-color: ${Colors.white};
  box-shadow: 0 0 34px ${rgba(Colors.coal, 0.13)}, -1px 1px 2px ${rgba(Colors.coal, 0.2)};
  padding-top: 15px;
  padding-bottom: 15px;
  min-width: 200px;
`;

const Item = styled.li``;

const Button = styled.button`
  ${Mixins.transition('background-color')};
  ${Mixins.resetButton()};
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  color: ${Colors.coal};
  font-weight: 500;
  padding: 10px 25px;
  width: 100%;

  &:hover {
    color: ${Colors.coal};
    background-color: ${Colors.ivory};
  }

  img {
    display: block;
    margin-right: 5px;
    width: 14px;
    height: 10px;
  }
`;
